export class DisposePolicyEntity {
  ChannelCode?: string;
}
export class ExtraInfoEntity {
  ExtraID?: string;
  ///<summary>扩展名称
  ///</summary>
  ExtraName?: string;
  ///<summary>扩展数据
  ///</summary>
  ExtraData?: string;
  ///<summary>扩展代码
  ///</summary>
  ExtraCode?: string;
  ///<summary>扩展组号(扩展行记录)
  ///</summary>
  ExtraGroup?: string;
  ///<summary>格式代码(text html url json xml)
  ///</summary>
  FormatCode?: string;
  ///<summary>目标编号
  ///</summary>
  IncludeID?: string;
  ///<summary>主要信息
  ///</summary>
  MasterID?: string;
  ///<summary>额外扩展(width)
  ///</summary>
  ExtraDataX?: string;
  ///<summary>额外扩展(height)
  ///</summary>
  ExtraDataY?: string;
  ///<summary>额外扩展(depth)
  ///</summary>
  ExtraDataZ?: string;
}
export class GoodsEntity {
  Prices?: PriceEntity[];
  strFlag?: string;
  ///<summary>商品编号
  ///</summary>
  GoodsID?: string;
  ///<summary>原始订单
  ///</summary>
  OriginID?: string;
  ///<summary>唯一编号
  ///</summary>
  UniqueID?: string;
  ///<summary>订单编号
  ///</summary>
  OrderID?: string;
  ///<summary>政策编号
  ///</summary>
  PolicyID?: string;
  ///<summary>商品类型
  ///</summary>
  GoodsType?: number;
  ///<summary>商品名称
  ///</summary>
  GoodsName?: string;
  ///<summary>商品单价
  ///</summary>
  GoodsPrice?: number;
  ///<summary>价格明细(例如:商品单价含机建 燃油 税)
  ///</summary>
  GoodsPriceDetails?: string;
  ///<summary>商品数量
  ///</summary>
  GoodsCount?: number;
  ///<summary>销售价
  ///</summary>
  SalesPrice?: number;
  ///<summary>采购价
  ///</summary>
  SupplyPrice?: number;
  ///<summary>处理状态
  ///</summary>
  DealStatus?: number;
  ///<summary>商品数据
  ///</summary>
  GoodsData?: string;
  ///<summary>供应订单号
  ///</summary>
  SupplyGoodsID?: string;
  ///<summary>客户订单编号
  ///</summary>
  ClientGoodsID?: string;
  ///<summary>创建时间
  ///</summary>
  CreateTime?: Date;
  CreateTimeEnd?: Date;
  ///<summary>创建人编号
  ///</summary>
  CreateUserID?: string;
  ///<summary>创建人编号
  ///</summary>
  CreateUserName?: string;
  ///<summary>修改时间
  ///</summary>
  UpdateTime?: Date;
  UpdateTimeEnd?: Date;
  ///<summary>修改人编号
  ///</summary>
  UpdateUserID?: string;
  ///<summary>修改人编号
  ///</summary>
  UpdateUserName?: string;
  ///<summary>备注
  ///</summary>
  Remark?: string;

  ///<summary>商品编号
  ///</summary>
}
export class ProductModel {
  ProductID?: string;
  ProduceID?: string;
  ConsumerDate?: Date;
  FinishedDate?: Date;
  Count?: number;
  LevelCode?: string;
}
export class PolicyModel {
  ConsumerCount?: number;
  PolicyID?: string;
  SupplyID?: string;
  CompanyID?: string;
  CustomerID?: string;
  Products?: ProductModel[];

  ProduceID?: string;
  BusinessType?: number;

  //机票
  ApplyArea?: number;
  Flight?: string;
  ProductID?: string;
  VoyageType?: number;
  BookingType?: number;
  ServiceType?: number;

  //酒店

  CityCode?: string;
  CityName?: string; //城市名称
  checkInDate?: string; //入住日期
  checkOutDate?: string; //退房日期
  propertyName?: string; //酒店名称
  hotelStar?: string; //星级
  minRate?: string; //最小价格
  maxRate?: string; //最大价格
  rankType?: number; //排序
  pageIndex?: number; //页码
  hotelType?: string;

  ArrivalDate?: string; //入住日期
  DepartureDate?: string; //退房日期
  QueryText?: string; //关键字
  LowRate?: string; //最小价格
  HighRate?: string; //最大价格
  StarRate?: string; //星级
  ThemeIds?: string; //特色
  Facilities?: string; //设施
  DistrictId?: string; //地区编码
  BusinessZoneId?: string; //商圈编码
  Sort?: string; //排序
  PageIndex?: number; //页码
  //BookingType//预定类型（因公/因私）
  //hotelType
  //CompanyID//当前登陆公司编号

  //UserCompanyID

  //PolicyID//差旅规则
  UserCompanyID?: string;
  //PolicyID
  HotelId?: string;

  HotelIds?: string;
  RoomID?: string;
  RatePlanID?: string;

  //火车

  CenterCostID?: string;
  /// <summary>
  /// 差旅目的
  /// </summary>
  TravelPurposeID?: string;
  /// <summary>
  /// 政策原因
  /// </summary>
  PolicyCauseID?: string;
  /// <summary>
  /// 项目代码
  /// </summary>
  ProjectCode?: string;
  /// <summary>
  /// 政策原因描述
  /// </summary>
  PolicyCauseDetail?: string;
  /// <summary>
  /// 当前座位信息
  /// </summary>

  /// <summary>
  /// 原火车订单号
  /// </summary>
  OldTrainOrder?: string;
  /// <summary>
  /// 是否改签
  /// </summary>
  IsTrainChange?: number;
  //public TrainOrderEntity OrderInfo

  ///// <summary>
  ///// 本地缓存的车次文件名
  ///// </summary>
  //TrainEntCode

  /// <summary>
  /// 座位类型
  /// </summary>
  seat_type?: string;

  from_station?: string;

  to_station?: string;

  train_date?: Date;

  train_code?: string;

  policy?: number;

  //Temporary

  //Frequent

  /// <summary>
  /// 是否违背政策
  /// </summary>
  IsBreachPolicy?: string;

  /// <summary>
  /// 乘客ID
  /// </summary>
  PassId?: string;

  /// <summary>
  /// 乘客姓名
  /// </summary>
  PassName?: string;
  /// <summary>
  /// 改签订单号
  /// </summary>
  TrainChangeID?: string;
  /// <summary>
  /// 预定方式
  /// </summary>
  ReservationMode?: number;

  CenterID?: string;
  TripIntent?: string;
  FlowID?: string;
  Applyarea?: number;
  BookingUserId?: string;
}

export class ConsumerInfo {
  ConsumerID?: string;
  ConsumerName?: string;
}
export class IProductModel {}
export class ISearchModel {
  Lang?: string;
  RuleID?: string;
}
export class ISearchResult {
  entities?: IProductModel[];
}

export class PolicyEntity {
  Products?: ProductEntity[];
  Goods?: GoodsEntity[];
  PolicyID?: string;
  ///<summary>原始订单
  ///</summary>
  OriginID?: string;
  ///<summary>原产品号
  ///</summary>
  SourceID?: string;

  SourceCode?: string;
  UniqueID?: string;
  OrderID?: string;
  ///<summary>政策名称
  ///</summary>
  PolicyName?: string;
  ///<summary>适用区域
  ///</summary>
  ApplyArea?: number;
  ///<summary>服务编号
  ///</summary>
  ServiceID?: number;
  ///<summary>服务名称
  ///</summary>
  ServiceName?: string;
  ///<summary>政策数据
  ///</summary>
  PolicyData?: string;
  ///<summary>供应编号
  ///</summary>
  SupplyID?: string;
  ///<summary>供应政策编号
  ///</summary>
  SupplyPolicyID?: string;
  ///<summary>客户编号
  ///</summary>
  ClientID?: string;
  ///<summary>客户政策编号
  ///</summary>
  ClientPolicyID?: string;
  ///<summary>创建时间
  ///</summary>
  CreateTime?: Date;
  CreateTimeEnd?: Date;
  ///<summary>创建人编号
  ///</summary>
  CreateUserID?: string;
  ///<summary>创建人编号
  ///</summary>
  CreateUserName?: string;
  ///<summary>修改时间
  ///</summary>
  UpdateTime?: Date;
  UpdateTimeEnd?: Date;
  ///<summary>修改人编号
  ///</summary>
  UpdateUserID?: string;
  ///<summary>修改人编号
  ///</summary>
  UpdateUserName?: string;
  /// <summary>
  /// 是否需要确认价格
  /// </summary>
  IsTwoConfirm?: number;
}
export class PriceEntity {
  GroupCode?: string;
  PriceCode?: string;
  ///<summary>价格编号
  ///</summary>
  PriceID?: string;
  ///<summary>原始订单
  ///</summary>
  OriginID?: string;
  GoodsID?: string;
  ///<summary>产品编号
  ///</summary>
  ProductID?: string;
  ///<summary>政策编号
  ///</summary>
  SourceID?: string;
  ///<summary>唯一编号
  ///</summary>
  UniqueID?: string;
  ///<summary>订单编号
  ///</summary>
  OrderID?: string;
  ///<summary>商品类型
  ///</summary>
  PriceType?: number;
  ///<summary>商品名称
  ///</summary>
  PriceName?: string;
  ///<summary>市场价
  ///</summary>
  MarketPrice?: number;
  ///<summary>销售价
  ///</summary>
  SalesPrice?: number;
  ///<summary>采购价
  ///</summary>
  SupplyPrice?: number;
  ///<summary>供应订单号
  ///</summary>
  SupplyPriceID?: string;
  ///<summary>客户订单编号
  ///</summary>
  ClientPriceID?: string;
  ///<summary>创建时间
  ///</summary>
  CreateTime?: Date;
  CreateTimeEnd?: Date;
  ///<summary>创建人编号
  ///</summary>
  CreateUserID?: string;
  ///<summary>创建人编号
  ///</summary>
  CreateUserName?: string;
  ///<summary>修改时间
  ///</summary>
  UpdateTime?: Date;
  UpdateTimeEnd?: Date;
  ///<summary>修改人编号
  ///</summary>
  UpdateUserID?: string;
  ///<summary>修改人编号
  ///</summary>
  UpdateUserName?: string;

  FeatureCode?: string;

  StandardPrice?: number;
}
export class ProductEntity {
  Features?: ProductFeature[];
  //子产品
  Products?: ProductEntity[];

  SelfPayment?: number;
  productProps?: ProductProps[];

  Extras?: ExtraInfoEntity[];
  ///<summary>产品编号
  ///</summary>
  ProductID?: string;
  ///<summary>原始订单
  ///</summary>
  OriginID?: string;
  ///<summary>原产品号
  ///</summary>
  SourceID?: string;
  PolicyID?: string;
  ///<summary>订单编号
  ///</summary>
  OrderID?: string;
  ///<summary>唯一编号
  ///</summary>
  UniqueID?: string;
  ///<summary>产品名称
  ///</summary>
  ProductName?: string;
  ///<summary>产品类型
  ///</summary>
  ProductType?: number;
  ///<summary>产品品牌
  ///</summary>
  ProduceID?: string;
  ///<summary>品牌代码
  ///</summary>
  ProduceCode?: string;
  ///<summary>品牌名称
  ///</summary>
  ProduceName?: string;
  ///<summary>产品级别(等级 规格)
  ///</summary>
  LevelID?: string;
  ///<summary>级别代码
  ///</summary>
  LevelCode?: string;
  ///<summary>级别名称 头等舱 商务舱 经济舱 9折经济舱 8折经济舱
  ///</summary>
  LevelName?: string;
  ///<summary>产品批次(团号 航班号 批次号 印刷批次)
  ///</summary>
  BatchID?: string;
  ///<summary>产品批次(团号 航班号 批次号 印刷批次)
  ///</summary>
  BatchCode?: string;
  ///<summary>消费地址
  ///</summary>
  ConsumerCityID?: string;
  ///<summary>消费地址
  ///</summary>
  ConsumerCityCode?: string;
  ///<summary>消费地址
  ///</summary>
  ConsumerCityName?: string;
  ///<summary>消费地址
  ///</summary>
  ConsumerZoneID?: string;
  ///<summary>消费地址
  ///</summary>
  ConsumerZoneCode?: string;
  ///<summary>消费地址
  ///</summary>
  ConsumerZoneName?: string;
  ///<summary>消费日期
  ///</summary>
  ConsumerDate?: Date;
  ConsumerDateEnd?: Date;
  ///<summary>消费地址
  ///</summary>
  ConsumerAddress?: string;
  ///<summary>消费地址
  ///</summary>
  FinishedCityID?: string;
  ///<summary>消费地址
  ///</summary>
  FinishedCityCode?: string;
  ///<summary>消费地址
  ///</summary>
  FinishedCityName?: string;
  ///<summary>消费地址
  ///</summary>
  FinishedZoneID?: string;
  ///<summary>消费地址
  ///</summary>
  FinishedZoneCode?: string;
  ///<summary>消费地址
  ///</summary>
  FinishedZoneName?: string;
  ///<summary>消费日期
  ///</summary>
  FinishedDate?: Date;
  FinishedDateEnd?: Date;
  ///<summary>消费地址
  ///</summary>
  FinishedAddress?: string;
  ///<summary>消费时间(飞行时间)
  ///</summary>
  ConsumerDuration?: number;
  ///<summary>产品数据
  ///</summary>
  ProductData?: string;
  ///<summary>供应订单号
  ///</summary>
  SupplyProductID?: string;
  ///<summary>客户订单编号
  ///</summary>
  ClientProductID?: string;
  ///<summary>创建时间
  ///</summary>
  CreateTime?: Date;
  CreateTimeEnd?: Date;
  ///<summary>创建人编号
  ///</summary>
  CreateUserID?: string;
  ///<summary>创建人编号
  ///</summary>
  CreateUserName?: string;
  ///<summary>修改时间
  ///</summary>
  UpdateTime?: Date;
  UpdateTimeEnd?: Date;
  ///<summary>修改人编号
  ///</summary>
  UpdateUserID?: string;
  ///<summary>修改人编号
  ///</summary>
  UpdateUserName?: string;

  ProduceOrderID?: string;

  //退改规则信息
  BackRule?: string;
  Breakfast?: string;
  ProducePhone?: string;
  ProduceLevel?: string;
  IdentifyCode?: string;
}
export class ProductProps {
  ConsumerID?: string;
  ConsumerCode?: string;
  ProductCount?: number;
}
export class ProductFeature {
  FeatureType?: number;
  FeatureCode?: string;
  FeatureData?: any;
}
export class BtripProductFeature extends ProductFeature {
  ContraryInfo?: string;
}
export class ExtrasModel {
  MasterID?: string;
  ExtraCode?: string;
  ExtraData?: string;
}
export class ProductInfo {
  ProduceCode?: string;
  ProduceName?: string;
  BatchCode?: string;
  ConsumerZoneName?: string;
  ConsumerZoneCode?: string;
  ConsumerCityCode?: string;
  ConsumerCityName?: string;
  FinishedZoneName?: string;
  FinishedZoneCode?: string;
  FinishedCityCode?: string;
  FinishedCityName?: string;
  ConsumerDate?: string;
  FinishedDate?: string;
  ConsumerDuration?: string;
  SourceId?: string;
  ProductId?: string;
  OriginID?: string;
  ProductCode?: string;
  Extras?: ExtrasModel[];
  Goods?: GoodsModel[];
  Products?: ProductInfo[];
  TrackProduces?: ProductInfo[];
  /// <summary>
  /// 产品图片
  /// </summary>
  ProductImages?: ImageModel[];
  /// <summary>
  /// 消费地址
  /// </summary>
  ConsumerAddress?: string;
  ProductName?: string;
  ProductPhone?: string;
  Latitude?: string;
  Longitude?: string;
  ProduceLevel?: string;
  ProductIntroduce?: string;
}
export class ImageModel {
  ImageKey?: string;
  Images?: string[];
}
export class GoodsModel {
  GoodsId?: string;
  ProductId?: string;
  SourceId?: string;
  GoodsName?: string;
  ChannelName?: string;
  ChannelCode?: string;
  GoodsCode?: string;
  GoodsLevel?: string;
  GoodsType?: string;
  GoodsCount?: string;
  //市场价（票面，房费）等
  MarketPrice?: number;

  //基础价格不含机建燃油的销售价
  BasisPrice?: number;

  //经过计算的单产品卖出价（含机建 燃油）
  SalesPrice?: number;

  GoodSource?: string;
  Discount?: number;
  Contrarys?: string[];
  Extras?: ExtrasModel[];
  Prices?: PriceEntity[];
}
export class ProductResult<T> {
  PageNo = 1;
  PageCount?: number;
  PageSize = 15;
  RecordCount?: number;
  ShoppingID?: string;
  filters?: any[];
  entities?: T[];
}
export class ProductInfoSearchModel {
  Wheres?: WhereModel[];
  Filters?: any[];
  BookingType?: number;
  Consumers?: string[];
  LevelId?: string;
  KeyWords?: string;
  ApplyArea?: number;
  AdultCount?: number;
  ChildCount?: number;
  InfantCount?: number;
  Lang?: string;
  ClientId?: string;
  CompanyId?: string;
  RuleID?: string;
  VoyageType?: number;
  PageSize?: number;
  PageNo?: number;
  GoodPrice?: number;
  LevelBerth?: string;
  ProductId?: string;
  TicketPrice?: number;
  PolicyCode?: string;
  SourceId?: string;
  UniqueId?: string;
  ShoppingID?: string;
  SelectId?: string[];
}
export class WhereModel {
  ZoneId?: string;
  ConsumerZoneCode?: string;
  FinishedZoneCode?: string;
  ConsumerDate?: Date;
  FinishedDate?: Date;
  OrderNo?: string;
  PolicyCode?: string;
  cid?: string;
}
